import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { VersionService } from 'src/app/services/version.service';
import { MatDialog } from '@angular/material/dialog';
import { VersionOtpComponent } from './version-otp/version-otp.component';

@Component({
  selector: 'app-version-update',
  templateUrl: './version-update.component.html',
  styleUrls: ['./version-update.component.css']
})
export class VersionUpdateComponent implements OnInit {
  versionForm: UntypedFormGroup;
  versionObject = { };
  updateBtnHide = true;
  changeBtnHide = false;
  api_error: any;
  api_success: any;
  disableUpdateBtn = false;
  disableCancelBtn = false;
  constructor(private formbuilder: UntypedFormBuilder, private versionService: VersionService, private dialog: MatDialog) {
    this.versionForm = this.formbuilder.group({
      apiVersion: [''],
      configVersion: [''],
      consumerAndroidVersion: [''],
      consumerIOSVersion: [''],
      providerAndroidVersion: [''],
      providerIOSVersion: ['']
    });
  }

  ngOnInit() {
    this.getLatestVersion();

  }
  getLatestVersion() {
    this.versionService.getLatestVersion()
    .subscribe(res => {
      console.log(res);
      this.setFormValues(res);
    });
  }
  setFormValues(values) {

    this.versionForm.patchValue({
      apiVersion: values.apiVersion,
      configVersion: values.configVersion,
      consumerAndroidVersion: values.consumerAndroidVersion,
      consumerIOSVersion: values.consumerIOSVersion,
      providerAndroidVersion: values.providerAndroidVersion,
      providerIOSVersion: values.providerIOSVersion
    });
    this.versionForm.disable();

  }
  onChangeVersion() {
    this.changeBtnHide = true;
    this.updateBtnHide = false;
    this.versionForm.enable();
  }
  onVersionUpdate() {
    this.disableUpdateBtn = true;
    this.disableCancelBtn = true;
    console.log(this.versionForm.value);
    this.versionService.updateVersion(this.versionForm.value)
    .subscribe(res => {
      this.disableUpdateBtn = false;
      this.disableCancelBtn = false;
      this.api_success = 'OTP has been send to email successfully,Please contact Superadmin';
      setTimeout(() => {
        this.showOtpFormforVerification();
      }, 2000);

    },
    (error) => {
      this.api_error = error.error;
      this.disableUpdateBtn = false;
      this.disableCancelBtn = false;
    });

  }
  onCancel() {
    this.getLatestVersion();
    this.changeBtnHide = false;
    this.updateBtnHide = true;

    this.api_error = '';
    this.api_success = '';
  }
  showOtpFormforVerification() {
    const dialogRef = this.dialog.open(VersionOtpComponent, {
      width: '800px',
      'data': this.versionForm.value
    });
    dialogRef.afterClosed().subscribe(response => {
      this.changeBtnHide = false;
      this.updateBtnHide = true;
      this.versionForm.disable();
      this.api_error = '';
      this.api_success = '';
      this.getLatestVersion();

});

}


}
